(() => {
  const params = new URLSearchParams(location.search);
  const preview = params.get('preview_theme_id');
  document.querySelectorAll('a[data-vehicle-quote]').forEach(link => {
    if (!/^\d+$/.test(preview || '')) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return;
    url.searchParams.set('preview_theme_id', preview);
    link.href = url.href;
  });
  if (params.get('request') !== 'custom-quote') return;
  const read = key => (params.get(key) || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0,160);
  const values = ['make','model','chassis','years'].map(read);
  if (!values.some(Boolean)) return;
  document.querySelectorAll('[data-vehicle-quote-context]').forEach(context => {
    if (context.dataset.ready) return;
    context.dataset.ready = 'true';
    const form = context.closest('form');
    const input = context.querySelector('input');
    input.value = values.filter(Boolean).join(' / ');
    input.disabled = false;
    context.hidden = false;
    const setChoice = (name, value) => {
      const select = form.elements.namedItem(name);
      if (!select || !value || select.value) return;
      if (![...select.options].some(option => option.value === value)) select.add(new Option(value,value));
      select.disabled = false;
      select.value = value;
      select.dispatchEvent(new Event('change',{bubbles:true}));
    };
    setChoice('contact[vehicle_make]',values[0]);
    setChoice('contact[vehicle_model]',values[1]);
    const part = form.elements.namedItem('contact[vehicle_part]');
    if (part) { part.required = true; part.setAttribute('aria-required','true'); }
  });
})();
